import React, { useContext } from "react";
import { Box, Button, Heading, ResponsiveContext } from "grommet";
import { TextInput } from "../../Inputs/TextInput";
import { isMobileTabletResponsive } from "../../../utils/utils";
export var CreateEventSection = function CreateEventSection() {
  var size = useContext(ResponsiveContext);
  var isMobileWidth = isMobileTabletResponsive(size);
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(
      Heading,
      {
        level: 2,
        margin: {
          bottom: "3rem",
        },
      },
      "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435"
    ),
    /*#__PURE__*/ React.createElement(
      Box,
      {
        flex: true,
        direction: "column",
        style: {
          borderRadius: "10px",
          backgroundColor: "#F8F8F8",
        },
        pad: "2rem",
        height: {
          min: "350px",
        },
      },
      /*#__PURE__*/ React.createElement(
        Box,
        {
          flex: true,
          direction: isMobileWidth ? "column" : "row",
          gap: "1rem",
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: "column",
            gap: "1rem",
          },
          /*#__PURE__*/ React.createElement(
            Box,
            null,
            /*#__PURE__*/ React.createElement(TextInput, null)
          ),
          /*#__PURE__*/ React.createElement(
            Box,
            null,
            /*#__PURE__*/ React.createElement(TextInput, null)
          ),
          /*#__PURE__*/ React.createElement(
            Box,
            null,
            /*#__PURE__*/ React.createElement(TextInput, null)
          )
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: "column",
            gap: "1rem",
          },
          /*#__PURE__*/ React.createElement(
            Box,
            null,
            /*#__PURE__*/ React.createElement(TextInput, null)
          ),
          /*#__PURE__*/ React.createElement(
            Box,
            null,
            /*#__PURE__*/ React.createElement(TextInput, null)
          )
        )
      ),
      /*#__PURE__*/ React.createElement(
        Box,
        {
          margin: {
            top: "10px",
          },
        },
        /*#__PURE__*/ React.createElement(
          Heading,
          {
            fill: true,
            level: 6,
            margin: {
              bottom: "8px",
            },
          },
          "\u0417\u0430\u044F\u0432\u043A\u0430 \u0440\u0430\u0441\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 3 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439"
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: "row",
            gap: "1rem",
          },
          /*#__PURE__*/ React.createElement(
            Button,
            null,
            "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C"
          ),
          /*#__PURE__*/ React.createElement(
            Button,
            null,
            "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435"
          )
        )
      )
    )
  );
};
